import { render, staticRenderFns } from "./ChartPolicyViolationBreakdown.vue?vue&type=template&id=b04d6c60&"
import script from "./ChartPolicyViolationBreakdown.vue?vue&type=script&lang=js&"
export * from "./ChartPolicyViolationBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports